module.exports = "<div class=\"dot1\"></div>\n<div class=\"dot2\"></div>\n<div class=\"dot3\"></div>\n"